import React from 'react';
import { useKernelData } from './data';
import { familyOf, famColor } from './palette';

// A band of the actual syscall table, running past.
//
// The number is abstract; watching `openat  mmap  clone3  io_uring_setup`
// stream by is not. Two rows drift in opposite directions so the band reads as
// a surface rather than a line, and hovering stops it so a name can be read.
// Each name wears the colour of its family (files, memory, processes...), the
// same hue the legend and the composition bar above it use.
const FALLBACK = ['read', 'write', 'openat', 'close', 'mmap', 'munmap', 'clone3', 'execve', 'futex', 'epoll_wait', 'io_uring_setup', 'statx'];

export default function Ticker() {
  const table = useKernelData('syscalls');
  const names = table?.names?.length ? table.names : FALLBACK;

  const half = Math.ceil(names.length / 2);
  const rows = [names.slice(0, half), names.slice(half)];

  return (
    <div className="ox-ticker" aria-hidden="true">
      {rows.map((row, index) => (
        <div className={`ox-ticker__row ox-ticker__row--${index === 0 ? 'left' : 'right'}`} key={index}>
          {/* Doubled so the loop has something to scroll into. */}
          {[0, 1].map((copy) => (
            <div className="ox-ticker__set" key={copy}>
              {row.map((name) => (
                <span className="ox-ticker__item" key={name} style={{ '--fam': famColor(familyOf(name)) }}>{name}</span>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
